import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { ICreateEmpresa } from './empresa.model';

@Injectable({
  providedIn: 'root'
})
export class EmpresaService {
  private http = inject(HttpClient);

  CreateEmpresa(body: ICreateEmpresa, guid: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      IdempotencyKey: guid
    });

    return this.http.post<any>(
      `${environment.baseURL}Empresa/CreateEmpresa`,
      body,
      { headers: headers }
    );
  }

  UpdateEmpresa(id: number, body: ICreateEmpresa): Observable<any> {
    return this.http.put<any>(
      `${environment.baseURL}Empresa/UpdateEmpresa?id=${id}`,
      body
    );
  }

  GetEmpresaById(id: number): Observable<any> {
    return this.http.get<any>(
      `${environment.baseURL}Empresa/GetEmpresaById?id=${id}`
    );
  }

  GetEmpresaByFilter(
    nomeEmpresa?: string,
    pageNumber?: number,
    pageSize: number = 8
  ) {
    const url = `${environment.baseURL}Empresa/GetEmpresas`;
    const params: any = {};

    if (nomeEmpresa !== undefined) {
      params.NM_FNTS_EPSA = nomeEmpresa;
    }
    if (pageNumber !== undefined) {
      params.PAGE_NUMBER = pageNumber;
    }
    if (pageSize !== undefined) {
      params.PAGE_SIZE = pageSize;
    }

    return this.http.get<any>(url, { params });
  }

  PatchEmpresa(id: number, status: number) {
    const url = `${environment.baseURL}Empresa/PatchEmpresaIsFaturada?id=${id}`;

    const body = {
      FL_FTRD_EPSA: status
    };

    return this.http.patch<any>(url, body);
  }

  public patchEmpresaRestSenha(
    token: string | null,
    senha: string
  ): Observable<any> {
    const body = {
      ResetToken: token,
      TX_SENH_EPSA: senha
    };
    return this.http.patch<any>(
      `${environment.baseURL}Empresa/PacthEmpresaResetSenha`,
      body
    );
  }
}
